// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import Products from "./pages/Products";
import Orders from "./pages/Orders";
import RFQs from "./pages/RFQs";
import Account from "./pages/Account";

import PrivateRoute from "./components/PrivateRoute.jsx";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route path="/dashboard" element={
          <PrivateRoute><Dashboard /></PrivateRoute>
        } />

        <Route path="/customers" element={
          <PrivateRoute><Customers /></PrivateRoute>
        } />

        <Route path="/products" element={
          <PrivateRoute><Products /></PrivateRoute>
        } />

        <Route path="/orders" element={
          <PrivateRoute><Orders /></PrivateRoute>
        } />

        <Route path="/rfqs" element={
          <PrivateRoute><RFQs /></PrivateRoute>
        } />

        <Route path="/account" element={
          <PrivateRoute><Account /></PrivateRoute>
        } />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
